import { useState, useEffect } from "react";

const useIsTabletOrLarger = () => {
  const [isTabletOrLarger, setIsTabletOrLarger] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTabletOrLarger(window.innerWidth >= 768); // Tailwind's `md` breakpoint
    };

    handleResize(); // Check size on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isTabletOrLarger;
};

export default useIsTabletOrLarger;
